import { render, staticRenderFns } from "./GoetelFooter.vue?vue&type=template&id=192b4d54&scoped=true&"
import script from "./GoetelFooter.vue?vue&type=script&lang=js&"
export * from "./GoetelFooter.vue?vue&type=script&lang=js&"
import style0 from "./GoetelFooter.vue?vue&type=style&index=0&id=192b4d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192b4d54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFooter,VSpacer})
